import { hasCode } from '@/api/errors'

/**
 * What a refused Pay means, for the refusals every product's `checkout/`
 * shares. Each product maps its own codes first (`payFailure` for plans,
 * `coursePayFailure` for courses) and hands the rest here.
 */

export const OFFLINE_MESSAGE = "You're offline. Connect and try again."
export const RATE_LIMITED_MESSAGE = 'Too many tries. Wait a few minutes and try again.'

export type StartFailure =
  /** 503: this gateway is not set up here. Grey it out; the others may still work. */
  | { kind: 'gateway' }
  /** Said beside Pay: offline, throttled, or a refusal nobody planned for. */
  | { kind: 'message'; text: string }

export function startFailure(error: unknown, online: boolean): StartFailure {
  if (hasCode(error, 'PAYMENT_GATEWAY_UNAVAILABLE')) return { kind: 'gateway' }
  if (hasCode(error, 'RATE_LIMITED')) return { kind: 'message', text: RATE_LIMITED_MESSAGE }
  return {
    kind: 'message',
    text: online ? "Couldn't start the payment. Try again." : OFFLINE_MESSAGE,
  }
}
